export default {
    /* GET_PROCESS_SUBJECTS_SUCCESS
    ---------------------------------------------------------------
    */
    GET_PROCESS_SUBJECTS_SUCCESS: (state, data) => {
        state.processSubjects = data.results
    },
    /* GET_PROCESS_ENTRIES_SUCCESS
    ---------------------------------------------------------------
    */
    GET_PROCESS_ENTRIES_SUCCESS: (state, data) => {
        state.processEntries = data.results
    },
    /* GET_PROCESS_ENTRY
    ---------------------------------------------------------------
    */
    GET_PROCESS_ENTRY_SUCCESS: (state, data) => {
        state.processEntryAttachments = data.processEntryAttachment
    },
    SET_WIKI_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_WIKI_FILTERS: state => {
        state.filters = state.setInitialWikiFilters()
    }
}